module.exports = __webpack_public_path__ + "static/media/icons-ic-cold-call-missed.f7c23679.svg";